import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Avaliadores = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_avaliadores, setLoadingavaliadores] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [avaliadores, setavaliadores] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { faculdade_id, faculdade_name, slug } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [avaliador_id, setavaliadorId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getavaliadores = async (page, search) => {

    let response = await Request.Get(`faculdade/get_avaliadores/${faculdade_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setavaliadores(response.avaliadores);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingavaliadores(false);


    }
  };

  const Deleteavaliador = async (avaliador_id) => {

    let response = await Request.Delete(`faculdade/delete_avaliador/${avaliador_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getavaliadores(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getavaliadores(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{`
                            ${t("evaluators")}
                        `}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{`
                                ${t("evaluators")}
                            `}</h3>

                            <p>
                                {user.empresa == null || user.empresa.change_text == false ? t("legacy_gerencie_os_avaliadores_da_instituicao") : t("legacy_gerencie_os_avaliadores_do_processo")

                }.
                            </p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>

                    {user?.empresa?.online_proccess === true &&

          <div
            className="process-info-card"
            style={{
              marginBottom: '24px'
            }}>


                            <div className="icon purple">
                                🔗
                            </div>

                            <div style={{ flex: 1 }}>

                                <span>
                                    {t("portal_evaluator")}
                                </span>

                                <strong
                style={{
                  wordBreak: 'break-all'
                }}>

                                    <a
                  href={`https://avaliador.ontest.com.br/${slug}/login`}
                  target="_blank"
                  rel="noopener noreferrer">

                                        {`https://avaliador.ontest.com.br/${slug}/login`}
                                    </a>
                                </strong>

                            </div>

                        </div>

          }

                    <div className="module-toolbar">

                        <Search
              placeholder={t("placeholder_search_evaluator")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingavaliadores(true);

                  Getavaliadores(1, value);

                }, 500);

              }} />


                        <Link
              to={`/avaliadores/register/${faculdade_id}`}
              className="btn-module-primary">


                            <FaListAlt />{`

                            ${t("legacy_adicionar_avaliador")}

                        `}</Link>

                    </div>

                    <div className="table-modern-card">

                        <table
              id="tech-companies-1"
              className="table table-striped">


                            <thead>

                                <tr>

                                    <th>{t("label_name")}</th>

                                    <th>{t("label_email")}</th>

                                    <th>{t("label_created_at")}</th>

                                    <th>{t("label_actions")}</th>

                                </tr>

                            </thead>

                            <tbody>

                                {!loading_avaliadores && avaliadores.map((item, id) =>

                <tr key={id}>

                                        <td>

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </td>

                                        <td>
                                            {item.email}
                                        </td>

                                        <td>

                                            {moment(item.created_at).
                    format('DD/MM/YYYY HH:mm')}

                                        </td>

                                        <td>

                                            <div className="actions-group">

                                                <Link
                        to={`/avaliadores/edit/${item.id}`}>


                                                    <button
                          className="action-btn info"
                          title={t("legacy_editar_avaliador_2")}>

                                                        <MdModeEdit />
                                                    </button>

                                                </Link>

                                                <button
                        className="action-btn danger"
                        title={t("legacy_excluir_avaliador")}
                        onClick={() => {

                          setavaliadorId(item.id);

                          setShowWarning(true);

                        }}>

                                                    <MdDelete />
                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                )}

                            </tbody>

                        </table>

                        {loading_avaliadores &&

            <div className="row m-0">

                                <div className="col-12 d-flex justify-content-center align-items-center">

                                    <CircularProgress />

                                </div>

                            </div>

            }

                    </div>

                    {!loading_avaliadores && avaliadores.length === 0 &&
          <TableEmptyState title={t("empty_no_evaluator_found")} icon="⭐" />
          }

                    <Pagination
            className={
            pagination.last_page === 1 ?
            "hide" :
            ""
            }
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px"
            }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {

              setLoadingavaliadores(true);

              let page = { ...pagination };

              page.current_page = value;

              setPagination(page);

              Getavaliadores(
                value,
                search_oficial
              );

            }} />


                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingavaliadores(true);
            Deleteavaliador(avaliador_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_este_avaliador_ele_nao_estara_mais_disp_5a8e24a5")}


        </SweetAlert>


            </div>

        </div>);

};

export default Avaliadores;
